import React, { useEffect, useState } from "react";
import { Loader2, FileText, Video, Link as LinkIcon, CheckCircle2, Download } from "lucide-react";
import empApi from "../../lib/empApi";

const TYPE_ICON = { PDF: FileText, VIDEO: Video, LINK: LinkIcon };

export default function EmpSop() {
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState(null);

  const load = () => empApi.get("/employee/sop").then(({ data }) => setItems(data.items)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const acknowledge = async (id) => {
    setBusy(id);
    try { await empApi.post(`/employee/sop/${id}/acknowledge`); load(); } catch { /* noop */ } finally { setBusy(null); }
  };

  const openItem = async (s) => {
    if (s.type !== "PDF" && s.url) {
      window.open(s.url, "_blank", "noopener");
      if (!s.acknowledged) acknowledge(s.id);
      return;
    }
    // PDF: fetch as blob with auth header then open
    setBusy(s.id);
    try {
      const res = await empApi.get(`/employee/sop/${s.id}/file`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      window.open(url, "_blank", "noopener");
      load();
    } catch { /* noop */ } finally { setBusy(null); }
  };

  if (!items) return <div className="flex h-64 items-center justify-center"><Loader2 className="animate-spin text-amber-400" /></div>;

  return (
    <div className="space-y-4" data-testid="emp-sop-page">
      <div className="flex items-center gap-2"><FileText size={20} className="text-amber-400" /><h2 className="font-heading text-xl font-bold text-white">SOP & Peraturan</h2></div>

      {items.length === 0 ? <p className="py-8 text-center text-sm text-slate-500" data-testid="emp-sop-empty">Belum ada SOP</p> : (
        <div className="space-y-3" data-testid="emp-sop-list">
          {items.map((s) => {
            const Icon = TYPE_ICON[s.type] || FileText;
            return (
              <div key={s.id} className="rounded-2xl border border-slate-800 bg-slate-800/40 p-4" data-testid={`emp-sop-${s.id}`}>
                <div className="flex items-start justify-between">
                  <div className="flex items-center gap-3">
                    <div className="rounded-lg bg-amber-500/15 p-2 text-amber-300"><Icon size={18} /></div>
                    <div>
                      <p className="font-semibold text-white">{s.title}</p>
                      <p className="text-xs text-slate-400">{s.category} · {s.type}</p>
                    </div>
                  </div>
                  {s.mandatory && <span className="rounded-full bg-red-500/15 px-2 py-0.5 text-[11px] font-semibold text-red-300">Wajib</span>}
                </div>
                <div className="mt-3 flex items-center gap-2">
                  <button onClick={() => openItem(s)} disabled={busy === s.id} data-testid={`emp-sop-open-${s.id}`}
                    className="flex flex-1 items-center justify-center gap-1.5 rounded-xl border border-slate-700 py-2 text-sm font-semibold text-slate-200 disabled:opacity-60">
                    {busy === s.id ? <Loader2 size={15} className="animate-spin" /> : (s.type === "PDF" ? <Download size={15} /> : <LinkIcon size={15} />)} Buka
                  </button>
                  {s.acknowledged
                    ? <span className="flex items-center gap-1 rounded-xl bg-emerald-500/15 px-3 py-2 text-sm font-semibold text-emerald-300" data-testid={`emp-sop-done-${s.id}`}><CheckCircle2 size={15} /> Selesai</span>
                    : <button onClick={() => acknowledge(s.id)} disabled={busy === s.id} data-testid={`emp-sop-ack-${s.id}`}
                        className="rounded-xl bg-gradient-to-r from-amber-400 to-orange-500 px-3 py-2 text-sm font-bold text-slate-900 disabled:opacity-60">Saya Mengerti</button>}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
